import { createSlice } from "@reduxjs/toolkit";

export const citySlice = createSlice({
  name: "city",
  initialState: {
    cities: [],
    isFetching: false,
    error: false,
  },
  reducers: {
    getCityStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    getCitySuccess: (state, action) => {
      state.isFetching = false;
      state.cities = action.payload;
    },
    getCityFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
  },
});

export const { getCityStart, getCitySuccess, getCityFailure } =
  citySlice.actions;

export default citySlice.reducer;
